
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engage/[client]/videos",
      function () {
        return require("private-next-pages/engage/[client]/videos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engage/[client]/videos"])
      });
    }
  